import { db } from '../lib/firebase';
import { collection, doc, getDoc, setDoc, deleteDoc, serverTimestamp, query, where, getDocs, onSnapshot, Unsubscribe } from 'firebase/firestore';

// Database structure: top-level collections
const COLL = 'watchlist';

export async function isInWatchlist(userId: string, contentId: string): Promise<boolean> {
  const id = `${userId}_${contentId}`;
  const ref = doc(db, COLL, id);
  const snap = await getDoc(ref);
  return snap.exists();
}

export async function addToWatchlist(userId: string, contentId: string, title?: string) {
  const id = `${userId}_${contentId}`;
  const ref = doc(db, COLL, id);
  await setDoc(ref, { userId, contentId, title: title || null, createdAt: serverTimestamp() }, { merge: true });
}

export async function removeFromWatchlist(userId: string, contentId: string) {
  const id = `${userId}_${contentId}`;
  const ref = doc(db, COLL, id);
  await deleteDoc(ref);
}

export async function toggleWatchlist(userId: string, contentId: string, title?: string): Promise<boolean> {
  const present = await isInWatchlist(userId, contentId);
  if (present) {
    await removeFromWatchlist(userId, contentId);
    return false;
  }
  await addToWatchlist(userId, contentId, title);
  return true;
}

export async function listWatchlist(userId: string): Promise<Array<{ contentId: string; title?: string | null }>> {
  const q = query(collection(db, COLL), where('userId', '==', userId));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ contentId: d.data().contentId as string, title: (d.data().title as string) || null }));
}

export function subscribeToWatchlist(
  userId: string, 
  callback: (items: Array<{ contentId: string; title?: string | null }>) => void
): Unsubscribe {
  const q = query(collection(db, COLL), where('userId', '==', userId));
  return onSnapshot(q, 
    (snapshot) => {
      const items = snapshot.docs.map(d => ({ 
        contentId: d.data().contentId as string, 
        title: (d.data().title as string) || null 
      }));
      callback(items);
    },
    (error) => {
      console.error('Watchlist listener error:', error);
      // Don't throw the error, just log it
      // The listener will automatically retry
    }
  );
}



